// extracted by mini-css-extract-plugin
export default {"container":"PolicyPage_container__tXvqV","title":"PolicyPage_title__09CZk","content":"PolicyPage_content__YLCh+","section":"PolicyPage_section__dmUJc"};